import type { HekateEventBus } from '@onshape/www-inertia';

const hekateBus: HekateEventBus = window.hekateEventBus;

export default hekateBus;
